import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import React, { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { selectThemeMode } from "./redux/theme/themeSlice.js";
import { themeSettings } from "./theme";
import PageNotFound from "./components/PageNotFound.jsx";
import LayoutMain from "./layouts/LayoutMain/LayoutMain.jsx";
import NFTDeatails from "./pages/NFTDeatails.jsx";
import NewFarm from "./pages/NewFarm/newFarm.jsx";
import NodeComponent from "./pages/Node/node.jsx";
import ClaimXbrComp from "./pages/claimXbr/claimxbr.jsx";
import { Bounce, ToastContainer } from 'react-toastify';


const App = () => {
  const themeMode = useSelector(selectThemeMode);
  const theme = useMemo(
    () => createTheme(themeSettings(themeMode)),
    [themeMode]
  );
  useEffect(() => {
    document.getElementById("root").style.backgroundColor =
      theme.palette.mode === "light" ? "#FFFFFF" : "#000";
  }, [theme]);


  return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <>
          <Routes>
            <Route path="/" element={<LayoutMain />}>
              <Route index element={<NodeComponent />} />
              <Route path="/node" element={<NodeComponent />} />
              <Route path="/home" element={<Navigate to="/node" replace />} />
              <Route path="/swap" element={<NewFarm />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
            <Route path="/nft-details/:nftId" element={<NFTDeatails />} />
            <Route path="/claim-xbr" element={<ClaimXbrComp />} />
          </Routes>

          <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        </>
      </ThemeProvider>
  );
};

export default App;
